import Poll from '../../../../src/components/partials/poll';
import * as React from 'react';
export default {
  Poll,
  React
};